<template>
	<div class="form__group">
		<multiselect
            :options="results"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="location"
            :loading="loading"
            :searchable="false"
            :multiple="multiple"
            :options-limit="10"
            :show-labels="false"
            v-model="selected"
            :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }"
        >
			<span slot="noOptions">Type a name to search offices...</span>
		</multiselect>

		<label class="form__label">{{ label }}</label>
		<div class="form__validation" slot="validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import API from './../../../api';
	import AjaxSelect from './AjaxSelect';

	export default {
		name: 'formControlOffice',
		mixins: [AjaxSelect],
		props: {
			label: {
				type: String,
				default: 'Office',
			},
			placeholder: {
				type: String,
				default: 'Select an office...',
			},
			member: {
				type: Number,
				required: true,
			},
		},
		methods: {
			getOffices() {
				this.results = [];
				this.loading = true;

				API.getMember(this.member)
                    .then(member => { this.results = member.offices || [] })
                    .finally(() => this.loading = false);
			},
			getItemFromCache(id) {
				return this.$store.getters['selectCache/getOffice'](id);
			},
			addItemToCache(office) {
				this.$store.commit('selectCache/addOffice', office);
			}
		},
		created() {
			if(this.member) {
				this.getOffices();
			}
		},
		watch: {
			member() {
				this.getOffices();
			}
		}
	}
</script>

